
  function scrollToTop() {
    const infoContainer = document.querySelector('.eva-custom-product-container .product__info-container');
    if (infoContainer) {
      infoContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  document.addEventListener('click', function(e) {
    if (
      (e.target.type === 'radio' && e.target.name && e.target.form) ||
      e.target.classList.contains('variant-swatch-image') ||
      e.target.classList.contains('variant-picker__swatch')
    ) {
      let productContainer = document.querySelector('.product');
      if (productContainer) {
        productContainer.classList.add('scroll__product--stacked');
      }
      setTimeout(scrollToTop, 100);
    }
  });

  document.addEventListener('variant:change', scrollToTop);


  document.addEventListener("DOMContentLoaded", function() {
    const body = document.body;
    if (body.classList.contains("overflow-hidden")) {
      body.style.overflow = "hidden";
    }
  });

